import { IPO } from "../actionTypes";

const initialState = {
    ipoDetails: [],
    pastIpo: [],
    ongoingIpo: [],
    upcomingIpo: [],
    ipoOrderbookRow: [],
    placeBids: [],
    cancelBids: [],
    termConditionIpo: [],
    //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
    isCMOT: false,
    //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End
};

const ipoReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case IPO.GET_ONGOING_IPO_SUCCESS:
            return {
                ...state,
                ongoingIpo: actions.payload


            };
        case IPO.GET_ONGOING_IPO_FAILURE:
            return {
                ...state,
                ongoingIpo: actions.payload,
            };
        case IPO.GET_FUTURE_IPO_SUCCESS:
            return {
                ...state,
                upcomingIpo: actions.payload


            };
        case IPO.GET_FUTURE_IPO_FAILURE:
            return {
                ...state,
                upcomingIpo: actions.payload,
            };
        case IPO.GET_PAST_IPO_SUCCESS:
            return {
                ...state,
                pastIpo: actions.payload


            };
        case IPO.GET_PAST_IPO_FAILURE:
            return {
                ...state,
                pastIpo: actions.payload,
            };
        case IPO.GET_IPO_DETAILS_SUCCESS:
            return {
                ...state,
                ipoDetails: actions.payload


            };
        case IPO.GET_IPO_DETAILS_FAILURE:
            return {
                ...state,
                ipoDetails: actions.payload,
            };

        case IPO.GET_PLACEMODIFY_BID_SUCCESS:
            return {
                ...state,
                placeBids: actions.payload,


            };
        case IPO.GET_PLACEMODIFY_BID_FAILURE:
            return {
                ...state,
                placeBids: actions.payload
            };
        case IPO.GET_ORDERBOOK_SUCCESS:
            return {
                ...state,
                ipoOrderbookRow: actions.payload,


            };
        case IPO.GET_ORDERBOOK_FAILURE:
            return {
                ...state,
                ipoOrderbookRow: actions.payload,


            };
        case IPO.GET_CANCELBID_SUCCESS:
            return {
                ...state,
                cancelBids: actions.payload,


            };
        case IPO.GET_CANCELBID_FAILURE:
            return {
                ...state,
                cancelBids: actions.payload,


            };
        case IPO.GET_TERMS_AND_CONDITION_SUCCESS_IPO:
            return {
                ...state,
                termConditionIpo: actions.payload,


            };
        case IPO.GET_TERMS_AND_CONDITION_FAILURE_IPO:
            return {
                ...state,
                termConditionIpo: actions.payload,


            };
        //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
        case IPO.UPDATE_IS_CMOT:
            return {
                ...state,
                isCMOT: actions.payload,
            };
        //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End
        default:
            return state;
    }

};

export default ipoReducer;